// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingSummaryResponse

import { BookingStatus } from './enums.gen';
import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BookingSummaryApiResponse = {
	id: string;
	date: string;
	status: BookingStatus;
	promoCodeId: string | null;
};

export type BookingSummary = {
	id: string;
	date: DateTime;
	status: BookingStatus;
	promoCodeId: string | null;
};

export function hydrateBookingSummary(data: BookingSummaryApiResponse): BookingSummary {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
	};
}